import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const ScriptedBlockConfigSchema = z.object({
  fn: z.string().min(1, {
    message: 'Script is required.',
  }),
});
export type ScriptedBlockConfig = z.infer<typeof ScriptedBlockConfigSchema>;

export const ScriptedBlockBaseSchema = z.object({
  type: z.literal(BlockType.ScriptedFlow),
  config: ScriptedBlockConfigSchema,
});

export const ScriptedBlockSchema = BaseFlowBlockSchema.merge(ScriptedBlockBaseSchema);

export type ScriptedFlowBlock = z.infer<typeof ScriptedBlockSchema>;
